// Saved views on the leads page — what "segments" were actually for. A view is
// a named snapshot of the filter state, re-applied against live data whenever
// it's opened, so it never goes stale the way a frozen list does.
//
// A view answers "which leads match this?" — it is a saved filter, re-run every
// time it is opened, not a frozen set of rows someone picked once.
import { scopedKey } from './userScope.js'

const STORAGE_BASE = 'revailosales.savedViews'
const storageKey = () => scopedKey(STORAGE_BASE)

const uid = () => `v_${Math.random().toString(36).slice(2, 9)}`

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(storageKey()))
    return Array.isArray(raw) ? raw : []
  } catch {
    return []
  }
}

function write(views) {
  try {
    localStorage.setItem(storageKey(), JSON.stringify(views))
  } catch {
    /* quota — the view just isn't saved */
  }
  return views
}

// Views are per lead category: a view built in one vertical makes no sense in another.
export function listViews(category) {
  const all = read()
  return category ? all.filter((v) => v.category === category) : all
}

// `state` is whatever the page needs to restore itself. Kept opaque on purpose
// so adding a filter doesn't require touching this file.
export function saveView(category, name, state) {
  const clean = (name || '').trim()
  if (!clean) return null
  const views = read()
  const existing = views.find((v) => v.category === category && v.name.toLowerCase() === clean.toLowerCase())
  if (existing) {
    // Same name in the same category overwrites — "save" on a view you just
    // tweaked should update it, not silently create a twin.
    existing.state = state
    existing.updatedAt = new Date().toISOString()
    write(views)
    return existing
  }
  const view = {
    id: uid(),
    category,
    name: clean,
    state,
    createdAt: new Date().toISOString(),
  }
  write([view, ...views])
  return view
}

export function deleteView(id) {
  write(read().filter((v) => v.id !== id))
}

export function renameView(id, name) {
  const clean = (name || '').trim()
  if (!clean) return null
  const views = read()
  const view = views.find((v) => v.id === id)
  if (!view) return null
  view.name = clean
  write(views)
  return view
}
